document.addEventListener('alpine:init', () => {
    Alpine.data('orderby', (initialSelected, options) => ({
        open: false,
        selected: initialSelected,
        options: options,
        get selectedName() {
            const option = this.options.find((o) => o.id === this.selected);
            return option ? option.name : '';
        },
        selectOption(id) {
            this.selected = id;
            this.open = false;
            this.$refs.realSelect.value = id;
            this.$refs.form.submit();
        },
    }));
});
